<template>
    <div>
        <div>Live Chat</div>
        <div class="ld-msg mb-4">Load Older Messages</div>
        <div style="
    grid-template-rows: 1fr 0fr;
    display: grid;
    height: 75vh;
">
            <div class="msg-c" ref="msg_history">
                <div
                    class="msg"
                    v-for="m in messages"
                    :key="m.id"
                    :class="m.type == 'mod' ? 'r-msg' : 'l-msg'"
                    >
                    <div class="msg-b">
                        <div class="uimg">
                        <img src="/assets/chat/user_basic.png" />
                        </div>

                        <div class="nm-bl-g">
                        <div class="uname">{{ m.user }}</div>

                        <div
                            class="block-ic-tx"
                            v-if="m.type != 'mod' && !isBlocked(m.member.id)"
                            @click="blockUser(m.member.id)"
                        >
                            <img
                            class="mr-1"
                            src="/assets/new-moderator/octicon_blocked-16.svg"
                            alt=""
                            />
                            Block
                        </div>
                        </div>

                        <div class="fav-i"></div>

                        <div class="msg-cnt" v-html="m.message"></div>

                        <div class="act-btns">
                        <div class="btn dl" @click="remove(m.id, $event)">
                            <img
                            class="mr-1"
                            src="/assets/new-moderator/Button-Delete-Chat.svg"
                            alt=""
                            />
                            Delete
                        </div>
                        </div>
                    </div>
                </div>

<!--                <div class="msg r-msg">-->
<!--                    <div class="msg-b">-->
<!--                        <div class="uimg"><img src="/assets/new-moderator/Thumbnail-Chat-Member.png" alt=""></div>-->
<!--                        <div class="nm-bl-g">-->
<!--                            <div class="uname">Gaurav Pai</div>-->
<!--                            <div class="md">Moderator</div>-->
<!--                        </div>-->
<!--                        <div class="fav-i"></div>-->
<!--                        <div class="msg-cnt">-->
<!--                            <div>publicy to: <span>Sushila Sharaf</span></div>-->
<!--                            <div>A 35-year-old woman presented with a two-week H/o breathlessness, palpitations, and generalized oedema.-->
<!--                            She had a H/o weight loss of week H/o breathlessness palpitati...</div>-->
<!--                        </div>-->
<!--                        <div class="act-btns">-->
<!--                            <div class="btn dl">-->
<!--                                <img class="mr-1" src="/assets/new-moderator/Button-Delete-Chat.svg" alt="">-->
<!--                                Delete-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                </div>-->
            </div>
            <div class="message-box">
                <textarea rows='1' type="text" class="message-input" placeholder="Type message..." v-model="msg"></textarea>
                <button type="button" class="message-submit" @click="send">Send</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props : ['messages','currentUser','joined','messageLoading','normalUsers','selectedUser'],
        name : 'Chat',
        data(){
            return {
                msg : null,
                user : this.currentUser,
                mess : [],
                isLoading : [],
                selected : [],
                selectedUserData : [],
                loadMessages : 1,
                msg_type : 'public',
                show_new : false,
            }
        },

        watch : {
            joined(v){
                console.log('joined');
                this.messages.push({
                    text_type : true,
                    message : v
                });
            },
            messageLoading(){
                this.isLoading = [];
            },
            selectedUser(v){
                this.selectedUserData = v;
            },
            'messages.length' : function(n,o){
                if(n > o){
                    this.show_new = true;
                    this.$nextTick(() => {
                        this.scrollToBottom()
                    })
                }
            }
        },
        updated() {
            this.mess = this.messages;
        },
        methods: {
            onDivInput(e){
                console.log(e);
                this.msg = e.target.innerHTML;
            },
            scrollToBottom() {
                console.log("Hello");
                const container = this.$refs.msg_history;
                container.scrollTop = container.scrollHeight;
                this.show_new = false;
            },
            send(){
                this.$emit('setMessage',{
                    'msg' : this.msg,
                    'user' : this.selectedUserData,
                    'msg_type' : this.msg_type,
                });
                console.log("Triggered");
                this.msg = null;
                this.selected = [];
            },
            remove(id){
                // this.isLoading.push(id);
                // this.$emit('removeMsg',id);
                var proceed = confirm("Are you sure you want to delete?");
                    if (proceed) {
                        this.isLoading.push(id);
                        this.$emit('removeMsg',id);
                    }
            },
            setStartMessage(id,starred){
                this.isLoading.push(id);
                this.$emit('setStar',{
                    id : id,
                    starred : starred,
                });
            },
            removeSelectedUser(){
                this.selectedUserData = [];
                this.$emit('removeSelectedUser');
            },
            loadData(){
                this.$emit('loadMessages');
            },
            getUser(id){
                let temp = this.normalUsers.find(user => user.user.userData.user_id == id);
                return temp ? temp.user.name : null;
            },
            blockUser(m){
                this.$emit('blockuser',m);
            },
            isBlocked(id){
                let user = this.normalUsers.filter(f => {
                    if(f.user.userData.block == 1 && f.user.userData.user_id == id){
                        return f;
                    }
                });
                if(user.length > 0){
                    return true;
                }
                return false;
            }
        },
    }
</script>
<style scoped>
    .ld-msg {
        padding: 5px;
        background: #E1F0FF;
        color: #3699FF;
        text-align: center;
        font-size: 12px;
        font-weight: 600;
    }
    .msg-c {
        overflow-y: auto;
        height: 500px;
    }
    .msg-c .msg {
        display: flex;
        align-items: flex-end;
    }
    .msg-b {
        display: grid;
        grid-template-columns: 0fr 1fr 0fr;
        grid-gap: 8px;
        max-width: 500px;
        margin-bottom: 20px;
        padding: 10px;
        border-radius: 15px;
        background: #F1FAFF;
    }
    .msg-b .uimg {
        width: 36px;
        height: 36px;
    }
    .msg-b .nm-bl-g {
        display: grid;
        line-height: 1;
    }
    .msg-b .nm-bl-g .uname {
        font-size: 16px;
        font-weight: 500;
    }
    .msg-b .nm-bl-g .block-ic-tx {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #F64E60;
        font-size: 12px;
        font-weight: 500;
    }
    .msg-cnt {
        grid-column: 1 / 4;
        grid-row: 2;
    }
    .act-btns {
        grid-column: 1 / 4;
        display: flex;
        justify-content: space-between;
        grid-gap: 5px;
    }
    .dl {
        display: inline-flex;
        background: #FFE2E5;
        color: #F64E60;
        font-weight: 600;
        font-size: 14px;
    }
    .message-box {
        display: flex;
    }
    .message-input {
        overflow: auto;
        max-height: 100px;
        padding: 10px;
        width: 100%;
        font-size: 16px;
        border-radius: 10px;
        background: #F5F8FA;
        border: none;
    }
    .message-submit {
        z-index: 1;
        top: 9px;
        right: 10px;
        color: #000;
        border: none;
        /* background: #c29d5f; */
        background: #85b1e4;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 1;
        padding: 6px 10px;
        border-radius: 5px;
        outline: none !important;
        transition: background .2s ease;
        cursor: pointer;
    }
    .msg-c .r-msg {
        flex-direction: column-reverse;
    }
    .r-msg .msg-b {
        background: #D7F9EF;
    }

</style>
